import { render, staticRenderFns } from "./create-fun-answer.vue?vue&type=template&id=69b7f7b8&scoped=true"
import script from "./create-fun-answer.vue?vue&type=script&lang=js"
export * from "./create-fun-answer.vue?vue&type=script&lang=js"
import style0 from "./create-fun-answer.vue?vue&type=style&index=0&id=69b7f7b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b7f7b8",
  null
  
)

export default component.exports